import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { pluck, map } from 'rxjs/operators';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { ImagilityBaseResponse } from '../data/models/response.model';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {
  encriptedData:any;

  constructor(private httpClient: HttpClient) { }

  getTemplate(userType, companyId, payload) {
    let url
    if (userType == 'company') {
      url = `/${userType}/${companyId}/documentTemplate/list`;
    }
    if (userType == 'attorney') {
      url = `/${userType}/${companyId}/documentTemplate`;
    }
    return this.httpClient.post(url, payload).pipe(
      pluck('data'),
      map((codes: Array<any>) => {
        return codes;
      })
    )
  }

  getEmailTemplateList(payload, category) {
    
    return this.httpClient.post(`/emailTemplates/list/EMALTEMPLT?tempCategory=${category.name}`, payload).pipe(
      pluck('data'),
      map((codes: Array<any>) => {
        return codes;
      })
    )
  }

  getEmailTemplateListInvoice(payload) {
    
    return this.httpClient.post(`/emailTemplate/list/EMALTEMPLT?tempCategory=BILLANDINVOICE&tempCategory=GENERIC`, payload).pipe(
      pluck('data'),
      map((codes: Array<any>) => {
        return codes;
      })
    )
  }


  getEmailTemplateCompleteList(payload) {
    
    return this.httpClient.post(`/emailTemplates/list/EMALTEMPLT`, payload).pipe(
      pluck('data'),
      map((codes: Array<any>) => {
        return codes;
      })
    )
  }

  createTemplate(payload) {
    return this.httpClient.post(`/company/${payload.companyId}/documentTemplate/save`, payload).pipe(
      map((response: ImagilityBaseResponse) => response)
    );
  }

  createEmailTemplate(payload) {
    return this.httpClient.post(`/emailTemplate/save`, payload).pipe(
      map((response: ImagilityBaseResponse) => response)
    );
  }

  deleteTemplate(companyId, documentTemplateId) {
    return this.httpClient.delete(`/company/${companyId}/documentTemplate/${documentTemplateId}`).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return true;
        }
      })
    )
  }

  deleteEmailTemplate(id) {
    return this.httpClient.delete(`/emailTemplates/${id}`).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return true;
        }
      })
    )
  }

  // getPlaceholder(visaType, petitionType) {
  //   return this.httpClient.get(`/documentTemplate/placeHolder/visaType/${visaType}/petitionType/${petitionType}`).pipe(
  //     map((data) => {
  //       return data;
  //     })
  //   );
  // }

  // getPlaceholder(visaType, petitionType,payload) {
  //   return this.httpClient.post(`/documentTemplate/placeHolder/visaType/${visaType}/petitionType/${petitionType}`,payload).pipe(
  //     map((data) => {
  //       return data;
  //     })
  //   );
  // }
  getPlaceholder(payload){
    return this.httpClient.post(`/documentTemplate/placeHolder`,payload).pipe(
          map((data) => {
            return data;
          })
        );

  }


  fetchTemplate(companyId, payload) {
    return this.httpClient.post(`/company/${companyId}/documentTemplate/fetch`, payload).pipe(
      pluck('data'),
      map((data) => {
        return data;
      })
    )
  }

  fetchEmailTemplate(data) {
    return this.httpClient.get(`/emailTemplates/${data}`).pipe(
      pluck('data'),
      map((data) => {
        return data;
      })
    )
  }

  createOwnTemplate(payload, companyId, petitionId, letterType) {
    return this.httpClient.post(`/company/${companyId}/petition/${petitionId}/letter/${letterType}`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  generatePreviewForOwnTemplate(companyId, petitionId, letterType) {
    return this.httpClient.post(`/company/${companyId}/petition/${petitionId}/letter/${letterType}/preview`, {}).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  getLastUsedTemplate(companyId, petitionId) {
    return this.httpClient.get(`/company/${companyId}/petition/${petitionId}/templateInfo`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200 || response.status === 204) {
          return response;
        }
      })
    );
  }

  getTemplateDetails(companyId, petitionId, letterType) {
    return this.httpClient.get(`/company/${companyId}/petition/${petitionId}/letter/${letterType}`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200 || response.status === 204) {
          return response;
        }
      })
    );
  }

  getAIGeneratedValue(searchQuery) {
    searchQuery = this.toEncrypt(searchQuery);
    return this.httpClient.get(`/getAiLetterTemplate/${searchQuery}`).pipe(
      map((response: ImagilityBaseResponse) => response)
    );
  }


  getEmailTemplate() { 
    return this.httpClient.get(`/getPlaceHoldersForCaseAutomation`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }

  getEmailTemplateSetup() { 
    return this.httpClient.get(`/emailTemplate/placeHolders/templateType/EMALTEMPLT`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }


  searchPlaceholdersApis(text) { 
    
    return this.httpClient.get(`/emailTemplate/placeHolders/templateType/EMALTEMPLT?searchText=${text}`).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response;
        }
      })
    );
  }


  toEncrypt(_data) {
    var pharase = 'c63a423527b24f65'
    var data = _data;
    var key  = CryptoJS.enc.Latin1.parse(pharase);
    var iv   = CryptoJS.enc.Latin1.parse(pharase);  
    var encrypted = CryptoJS.AES.encrypt(
      data,
      key,
      {iv:iv,mode:CryptoJS.mode.CBC,
        padding:CryptoJS.pad.ZeroPadding
    }).toString();

    var e64 = CryptoJS.enc.Base64.parse(encrypted);
    var eHex = e64.toString(CryptoJS.enc.Hex);

   return this.encriptedData = eHex
  }
 
}
